import {Route} from "react-router-dom";
import {ListPage} from "../container/ListPage";
import {ViewPanel} from "../container/ViewPanel";
import {ManagePage} from "../container/ManagePage";

const indicatorsRoutes = [
    <Route key="indicators-manage" path="" element={<ManagePage />}>
        <Route key="indicators-list" path="list" element={<ListPage />}>
            <Route key="indicators-info" path="info/:id" element={<ViewPanel />} />
        </Route>
    </Route>,
];

export default indicatorsRoutes;
